// extracted by mini-css-extract-plugin
export default {"fee_tier_container":"FeeTier_fee_tier_container__ini3a","fee_tier":"FeeTier_fee_tier__TERJV","apr":"FeeTier_apr__LuU2i"};